module.exports = __webpack_public_path__ + "static/media/iconoEviar1.73b0ea76.png";